import { motion } from "motion/react";
import { RotatingTextBase, type RotatingTextBaseProps } from "@core/ui";

export type Props = Omit<RotatingTextBaseProps, "renderText" | "texts"> & {
  /** Array of texts to rotate through */
  dynamicTexts: string[];
};

/**
 * Styled rotating text component wrapping RotatingTextBase.
 * Cycles through an array of texts with fade animations.
 */
export const RotatingText = ({
  className = "",
  dynamicTexts = [],
  intervalDuration = 5,
  ...props
}: Props) => {
  return (
    <RotatingTextBase
      texts={dynamicTexts}
      intervalDuration={intervalDuration}
      className={className}
      data-testid="rotating-text"
      renderText={({ text, index: _index, isActive }) =>
        isActive ? (
          <motion.span
            key={text}
            transition={{ duration: 1 }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="text-brand-600"
          >
            {text}
          </motion.span>
        ) : null
      }
      {...props}
    />
  );
};

export default RotatingText;

